import React, { useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const Tabs = () => {
    const navigate = useNavigate();

    const handleNavigation = (path) => {
        navigate(path);
    };

    const handleLogout = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "You will be logged out of your account!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes!",
            cancelButtonText: "Cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                localStorage.removeItem("customer_id");
                localStorage.removeItem("token");
                window.location.href = "/"; // Redirect to home page after logout
            }
        });
    };

    return (
        <div className="dashboard-menu">
            <ul className="nav flex-column" role="tablist">
                <li className="nav-item">
                    <NavLink
                        className="nav-link"
                        to='/MyAccount'
                        id="dashboard-tab"
                        data-bs-toggle="tab"
                        role="tab"
                        aria-controls="dashboard"
                        onClick={() => handleNavigation('/MyAccount')}
                    >
                        <i className="fi-rs-settings-sliders mr-10" />Dashboard
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink
                        className="nav-link"
                        to='/MyOrders'
                        id="orders-tab"
                        data-bs-toggle="tab"
                        role="tab"
                        aria-controls="orders"
                        onClick={() => handleNavigation('/MyOrders')}
                    >
                        <i className="fi-rs-shopping-bag mr-10" />My Orders
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink
                        className="nav-link"
                        to='/MyAddress'
                        id="address-tab"
                        data-bs-toggle="tab"
                        role="tab"
                        aria-controls="address"
                        onClick={() => handleNavigation('/MyAddress')}
                    >
                        <i className="fi-rs-marker mr-10" />My Address
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink
                        className="nav-link"
                        to='/MyAccountDetails'
                        id="account-detail-tab"
                        data-bs-toggle="tab"
                        role="tab"
                        aria-controls="account-detail"
                        onClick={() => handleNavigation('/MyAccountDetails')}
                    >
                        <i className="fi-rs-user mr-10" />Account details
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink to="/"
                        className="nav-link"
                        onClick={(e) => {
                            e.preventDefault(); handleLogout();
                        }}>
                        <i className="fi-rs-sign-out mr-10" />
                        Log out
                    </NavLink>
                </li>
            </ul>
        </div >
    );
};

export default Tabs;
